export const ottParamName = 'ott';
export const appUrlParamName = 'appUrl';
